// src/ErrorModal.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ErrorModal = ({ show, handleClose, errorMessage,errorCode }) => {
  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{errorCode}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-danger">
      <p>{errorMessage}</p>
      
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
